module.exports = __webpack_public_path__ + "img/gun-zagreus.83f0f5bc.jpg";